var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3656 4.23431C13.678 4.54673 13.678 5.05327 13.3656 5.36569L6.96559 11.7657C6.65317 12.0781 6.14664 12.0781 5.83422 11.7657L2.63422 8.56569C2.3218 8.25327 2.3218 7.74673 2.63422 7.43431C2.94664 7.1219 3.45317 7.1219 3.76559 7.43431L6.3999 10.0686L12.2342 4.23431C12.5466 3.9219 13.0532 3.9219 13.3656 4.23431Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/GrayCheck.5e6251931cc964948c39f7c175f38338.svg";
export { ForwardRef as ReactComponent };